import { useTranslation } from 'react-i18next';

import { useServerReachable } from '@/shared/hooks/useServerReachable';

/**
 * Pastille « Hors ligne », posée une seule fois pour toute l'application.
 *
 * Quand le serveur ne répond plus, le site continue sur son cache : les écrans
 * restent pleins, et c'est précisément pour cela qu'il faut le dire. Sans la
 * pastille, un fil resté d'hier passerait pour le fil du jour. Elle ne capte
 * aucun clic et disparaît d'elle-même au retour du réseau : un état, pas une
 * alerte. Le gris encre suffit : ni rouge (rien n'est cassé), ni or.
 */
export function OfflineBanner() {
  const { t } = useTranslation();
  const reachable = useServerReachable();
  if (reachable) {
    return null;
  }
  return (
    <div
      role="status"
      className="pointer-events-none fixed inset-x-0 bottom-[calc(76px+env(safe-area-inset-bottom,0px))] z-40 flex justify-center md:bottom-6"
    >
      <span className="animate-fade-up rounded-pill bg-fg/90 px-3.5 py-1.5 text-caption text-bg shadow-floating">
        {t('state.offline')}
      </span>
    </div>
  );
}
